import axios from 'axios';
import ss from './Session';

const randomString = (length: number) =>
  new Array(length).fill(0)
    .map((x) => String.fromCharCode(65 + Math.floor(Math.random() * 2) * 32 + Math.floor(Math.random() * 26)))
    .join("");

export async function logBehavior (what: string, detail?: any) {

    if (!detail){
        detail = {}
    }

    if (!detail.page){
        detail.page = window.location.pathname;
    }

    if (!sessionStorage.getItem('sessionid')){
        let currentTime = (new Date()).getTime()/1000;
        let sessionid = localStorage.getItem('sessionid');
        
        if (!sessionid){
            sessionid = randomString(16);
            localStorage.setItem('sessionid', sessionid);
            localStorage.setItem('session:firstStartedAt', `${currentTime}`);

            await sendBehavior("sessionStart", {});
        }else {
            await sendBehavior("revisit", {
                interval: currentTime - Number(localStorage.getItem('session:lastStartedAt') || '0'),
                intervalFromStart: currentTime - Number(localStorage.getItem('session:firstStartedAt') || '0'),
            });
        }
        localStorage.setItem('session:lastStartedAt', `${currentTime}`);
        sessionStorage.setItem('sessionid', sessionid);
    }

    return await sendBehavior(what, detail);
}

async function sendBehavior (what: string, detail: any) {
    let sessionid = localStorage.getItem('sessionid');
    if (!detail.page){
        detail.page = window.location.pathname;
    }
    
    if (['127.0.0.1', 'localhost:3000', 'mydomain.com:3000', 'localhost:3001', 'mydomain.com:3001', 'd26pjf3a18hvh4.cloudfront.net', 'dev.webtoon.today', 'challenge-dev.webtoon.today'].indexOf(window.location.host) >= 0){
        detail.debug = true;
    }
    
    let userid = ss.getCurrentSession().userid;
    try{
        let res = await axios.post('https://admin-api.webtoon.today/behavior', {logs:[ {what, userid, sessionid, detail} ]}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            
            return true;

        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}

export async function logBulkBehavior (arr: {what: string, detail: any}[]) {
    
    
    let userid = ss.getCurrentSession().userid;
    let sessionid = localStorage.getItem('sessionid');

    let logs = arr.map(row => ({
        sessionid,
        userid,
        what: row.what,
        detail: {
            page: window.location.pathname,
            ...(row.detail),
            ...((['127.0.0.1', 'localhost:3000', 'mydomain.com:3000', 'localhost:3001', 'mydomain.com:3001', 'd26pjf3a18hvh4.cloudfront.net', 'dev.webtoon.today', 'challenge-dev.webtoon.today'].indexOf(window.location.host) >= 0)
                ?{debug: true}:{})
        },
    }))
    try{
        let res = await axios.post('https://admin-api.webtoon.today/behavior', {logs}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            
            return true;

        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}